import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="dev" transform="translate(11.000000, 5.000000)">
        {/* Add logo svg into loading */}
        <svg
          width="50px"
          height="50px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          x="15%"
          y="15%">
          <g id="SVGRepo_bgCarrier" strokeWidth="0" />

          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

          <g id="SVGRepo_iconCarrier">
            {' '}
            <path
              d="M9.49997 12.4L5 17.7999"
              stroke="#e965e9"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />{' '}
            <path
              d="M9.49997 12.4L5 7"
              stroke="#e965e9"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />{' '}
            <line
              x1="18"
              y1="18"
              x2="10"
              y2="18"
              stroke="#e965e9"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />{' '}
          </g>
        </svg>
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
